module.exports = __webpack_public_path__ + "media/fonts/lineto-circular-medium-ac87254c922666ef2b93a7ea9874f805.ttf";